import React, { useEffect, useState } from 'react'

const ImageLoad = ({ style, useNoHeight, ...props }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [height, setHeight] = useState(32);

    const loaded = () => {
        setIsLoaded(true)
        setHeight(style?.height ? style?.height : false);
    }

    return (
        <img
            {...props}
            onLoad={loaded}
            style={{
                ...style,
                // height: height,
                opacity: isLoaded ? 1 : 0, // Initially set opacity to 0, then gradually increase it to 1
                transition: 'opacity 1s ease-in-out', // Transition effect for opacity change
            }}
        />
    )
}

export default ImageLoad;